module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-ramen-aa8b4c1bf93857a1c0a7d034fb8fb15a.png";